import { drawerEdgeResizePlugin } from './drawerEdgeResizePlugin.js';
import { panelDrawerWidthStorage } from '@/ui/adapters/drawerWidth';

export const GLOBAL_NAV_DRAWER_WIDTH_STORAGE_KEY = 'solvit-global-nav-drawer-width';
export const GLOBAL_NAV_DRAWER_DEFAULT_WIDTH = 330;
export const GLOBAL_NAV_DRAWER_MIN_WIDTH = 240;
export const GLOBAL_NAV_DRAWER_MAX_WIDTH = 560;

export function clampGlobalNavDrawerWidth(width) {
  if (
    typeof width === 'number' &&
    !Number.isNaN(width) &&
    width >= GLOBAL_NAV_DRAWER_MIN_WIDTH &&
    width <= GLOBAL_NAV_DRAWER_MAX_WIDTH
  ) {
    return width;
  }
  return GLOBAL_NAV_DRAWER_DEFAULT_WIDTH;
}

export async function readGlobalNavDrawerWidth() {
  try {
    const saved = await panelDrawerWidthStorage.get(GLOBAL_NAV_DRAWER_WIDTH_STORAGE_KEY);
    return clampGlobalNavDrawerWidth(saved);
  } catch {
    return GLOBAL_NAV_DRAWER_DEFAULT_WIDTH;
  }
}

/**
 * 글로벌 내비게이션 드로어 — 오른쪽 가장자리 드래그로 width 조절 (IndexedDB 저장)
 */
export const globalNavDrawerResizePlugin = {
  id: 'global-nav-drawer-resize',

  attach(containerEl, ctx = {}) {
    return drawerEdgeResizePlugin.attach(containerEl, {
      edge: 'right',
      minWidth: GLOBAL_NAV_DRAWER_MIN_WIDTH,
      maxWidth: GLOBAL_NAV_DRAWER_MAX_WIDTH,
      storageKey: GLOBAL_NAV_DRAWER_WIDTH_STORAGE_KEY,
      storage: panelDrawerWidthStorage,
      handleClass: 'drawer-edge-resize-handle global-nav-drawer-resize-handle',
      ...ctx
    });
  }
};
